import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: () => import(/* webpackChunkName: "aboutUs" */ '../views/AboutUs.vue')
  },
  {
    path: '/joinUs',
    name: 'joinUs',
    component: () => import(/* webpackChunkName: "joinUs" */ '../views/JoinUs.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import(/* webpackChunkName: "product" */ '../views/product/ProductList.vue')
  },
  {
    path: '/mobile',
    name: 'mobile',
    component: () => import(/* webpackChunkName: "mobile" */ '../views/product/mobileList.vue')
  },
  {
    path: '/productInfo/:id',
    name: 'productInfo',
    component: () => import(/* webpackChunkName: "productInfo" */ '../views/product/ProductInfo.vue')
  },
  {
    path: '/serve',
    name: 'serve',
    component: () => import(/* webpackChunkName: "serve" */ '../views/ServeAndDownload.vue')
  },
  {
    path: '/newsList',
    name: 'newsList',
    component: () => import(/* webpackChunkName: "newsList" */ '../views/news/NewsList.vue')
  },
  {
    path: '/newsInfo/:id',
    name: 'newsInfo',
    component: () => import(/* webpackChunkName: "newsInfo" */ '../views/news/NewsInfo.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  // scrollBehavior() {
  //   return { top: 0 };
  // }
})

export default router
